import type { TranslationKeysError } from '../localeType';

export const frFR_error: TranslationKeysError = {
  error: 'Erreur :',
  // Update ORDER
  ORDER_NOT_FOUND: `La commande n'a pas été trouvée`,
  ORDER_SUSPENDED: `La commande est suspendue`,
  ORDER_IN_USE: `La commande est déjà en cours d'utilisation`,
  FLORIST_NOT_FOUND: `L'identifiant du fleuriste n'a pas été trouvé`,
  NOTIFICATION_CHANNEL_EMPTY: `Une erreur s'est produite dans le système`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `La commande ne peut pas être mise à jour dans ce statut`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `La commande ne peut pas être mise à jour par l'utilisateur`,
  UPDATE_KO: `Le statut de la commande a été mis à jour mais il y a une erreur à vérifier concernant la facturation`,
  EXCEPTION: `La commande ne peut pas être mise à jour. Une erreur s'est produite`,
  UNKNOWN_EXCEPTION: `La commande ne peut pas être mise à jour. Une erreur s'est produite`,
  OrderNotFoundException: `La commande n'a pas été trouvée dans le système`,
  IncorrectOrderActionException: `L'action demandée n'est pas supportée`,
  OrderStatusNotConsistentException: `Le nouveau statut demandé pour la commande n'est pas possible`,
  InvariantException: `Erreur technique dans le système : HTTP BAD REQUEST`,

  // POST ORDER
  IncorrectBodyModelException: `Transmission impossible : Erreur interne - Code erreur : PO-01`,
  IncorrectOrderException: `Transmission impossible : Erreur interne - Code erreur : PO-02`,
  BadRequestException: `Transmission impossible : Erreur interne - Code erreur : PO-03`,
  Exception: `Transmission impossible : Erreur interne - Code erreur : PO-04`,
  FeasabilityExceptionRaoKo: 'Transmission impossible : Erreur interne - Code erreur : PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Transmission impossible : Erreur interne - Code erreur : PO-06`,
  FeasabilityExceptionEmptyFlorists: 'Transmission impossible : Erreur interne - Code erreur : PO-07',
  PersonalCodeExceptionPersonalCodeNotFound: `Transmission impossible : Erreur interne - Code erreur : PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Transmission impossible : Erreur interne - Code erreur : PO-09`,
  ValidationException: 'Validation de la commande impossible (champs manquants) - Code erreur : PO-10',
  PersonalCodeNeededPsm: 'Accord préalable necessaire pour produit sur mesure (PSM) - Code erreur : PO-11',
  PersonalCodeNeededXProduct:
    'Accord préalable necessaire pour produit avec un code finissant par X - Code erreur : PO-12',
  PersonalCodeNeededPrice:
    'Le prix est supérieur à la très grande taille, un code AP est nécessaire - Code erreur : PO-12',
  PersonalCodeNeededPreparationTime:
    'Accord préalable necessaire, temps de préparation trop court - Code erreur : PO-13',
  PersonalCodeNeededHourLimit:
    'Accord préalable necessaire, délai de livraison trop court pour le moment choisit - Code erreur : PO-14',
  SelectedExecutingFloristNotFound: `Le fleuriste exécutant n'as pas été trouvé - Code erreur : PO-15`,
  UpdatePersonalCodeKO: 'Impossible de mettre à jour le code AP car il est déjà utilisé.',

  //LOGIN
  loginError: {
    floristUnknown: {
      title: `L'identifiant du fleuriste n'a pas été trouvé.`,
      body: `Merci de cliquer sur le bouton "Se déconnecter".`,
    },
    noCountryCode: {
      title: `Le code pays du fleuriste n'a pas été trouvé.`,
      body: `Merci de cliquer sur le bouton "Se déconnecter".`,
    },
    logoutButton: 'Se déconnecter',
  },
};
